import { useQuery } from "@tanstack/react-query";
import { getArticlesByProductArticleId } from "../services/medias.service";
import { QueryKeys } from "./queryKeys";

export const useArticlesByProductArticleId = (
  mediaId: string | undefined,
  productArticleId: string | undefined
) => {
  return useQuery({
    queryKey: [
      QueryKeys.ArticlesByMediaAndProductArticleId,
      { mediaId, productArticleId },
    ],
    queryFn: () =>
      getArticlesByProductArticleId(mediaId || "", productArticleId || ""),
    enabled: !!mediaId && !!productArticleId,
  });
};
